import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {Country, EventItem, Lookups, Race} from "@model";
import {LiveItemStatus} from "../../model/live-item-status";
import {LocalizedDatePipe} from "@pipes";
import dayjs from "dayjs";
import {environment} from "@environment";

@Component({
  selector: 'app-live-results-heading',
  templateUrl: './live-results-race-heading.component.html',
  styleUrls: ['./live-results-race-heading.component.scss']
})
export class LiveResultsRaceHeadingComponent {
  @Input() type: LiveResultHeadingType = LiveResultHeadingType.EVENT;
  @Input() event: EventItem | undefined = undefined;
  @Input() race: Race | undefined = undefined;
  @Input() finished: number = 0;
  @Input() started: number = 0;

  @Input() cssClass: string | undefined;
  @Input() hideStatusBadge: boolean | undefined = false;

  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Output() onClick = new EventEmitter<void>();

  localizedDatePipe: LocalizedDatePipe;
  status: LiveItemStatus = LiveItemStatus.TO_BE_STARTED
  dateString: string = "";
  country: string | undefined;

  constructor(public translocoService: TranslocoService) {
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit() {
    this.formatDate();
    this.getCountryName(this.race?.startCountry ?? this.event?.country);
    if (this.type === LiveResultHeadingType.EVENT) {
      this.startTimer(this.event?.start, this.event?.end)
    } else {
      this.startTimer(this.race?.raceStart, this.race?.raceEnd)
    }
  }


  formatDate() {
    const start = this.type === LiveResultHeadingType.RACE ? this.race?.raceStart : this.event?.start;
    const end = this.type === LiveResultHeadingType.RACE ? this.race?.raceEnd : this.event?.end;
    if (start && end) {
      if (this.type === LiveResultHeadingType.EVENT) {
        if (dayjs(start).isSame(dayjs(end), 'days')) {
          this.dateString = `${this.localizedDatePipe.transform(start)} - ${this.localizedDatePipe.transform(end, "HH:mm")}`
        } else {
          this.dateString = `${this.localizedDatePipe.transform(start)} - ${this.localizedDatePipe.transform(end)}`
        }
      }
      if (this.type === LiveResultHeadingType.RACE) {
        this.dateString = `${this.localizedDatePipe.transform(start, 'shortDate')}`
      }
    }
  }


  private startTimer(startDate: Date | undefined, endDate: Date | undefined): void {
    if (startDate && endDate) {
      const start = new Date(startDate).getTime();
      const end = new Date(endDate).getTime();
      const now = new Date().getTime();
      const limit = environment.dayInSeconds;
      if (now < start) {
        this.status = LiveItemStatus.TO_BE_STARTED;
        if (now + limit > start) {
          setTimeout(() => {
            this.status = LiveItemStatus.IN_PROGRESS;
            if (limit > end - start) {
              setTimeout(() => {
                this.status = LiveItemStatus.FINISHED;
              }, end - start);
            }
          }, start - now);
        }
        return
      }
      if (now > end) {
        this.status = LiveItemStatus.FINISHED;
        return
      } else {
        this.status = LiveItemStatus.IN_PROGRESS;
        if (now + limit > end) {
          setTimeout(() => {
            this.status = LiveItemStatus.FINISHED;
          }, end - now);
        }
        return;
      }
    }
  }

  onHeadingClick() {
    this.onClick.emit()
  }

  getCountryName(countryCode: number | undefined) {
    this.countries?.find((country: Country) => {
      if (countryCode === country.id) {
        this.country = this.translocoService.translate("app.common.country." + country.id);
      }
    });
  }

  protected readonly LiveItemStatus = LiveItemStatus;
  protected readonly LiveResultHeadingType = LiveResultHeadingType;
}

export enum LiveResultHeadingType {
  RACE,
  EVENT
}
